/* By Lilo 2.0 — schil: mobiel menu + header-overlay-gedrag op pagina's met dag/nacht-hero */
(function () {
  function init() {
    // Header-overlay-mode zodra er een dag/nacht-hero op de pagina staat
    var heroWrap = document.querySelector('.bl-herowrap');
    var root = document.documentElement;
    root.classList.toggle('bl-hero-page', !!heroWrap);

    if (heroWrap) {
      var onScroll = function () {
        var past = heroWrap.getBoundingClientRect().bottom <= 0;
        root.classList.toggle('bl-past-hero', past);
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }

    // Mobiel fullscreen menu
    var overlay = document.querySelector('.bylilo-menu-overlay');
    if (!overlay) return;
    document.querySelectorAll('[data-bl-menu-open]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        overlay.setAttribute('data-open', '');
        document.body.style.overflow = 'hidden';
      });
    });
    overlay.querySelectorAll('[data-bl-menu-close], nav a').forEach(function (el) {
      el.addEventListener('click', function () {
        overlay.removeAttribute('data-open');
        document.body.style.overflow = '';
      });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && overlay.hasAttribute('data-open')) {
        overlay.removeAttribute('data-open');
        document.body.style.overflow = '';
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
